var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Pause, PlayArrow } from "@material-ui/icons";
import { Box, CircularProgress, IconButton, } from "@material-ui/core";
export var AudioControlButton = function (_a) {
    var onPause = _a.onPause, onPlay = _a.onPlay, isPlaying = _a.isPlaying, isLoading = _a.isLoading, _b = _a.iconButtonProps, iconButtonProps = _b === void 0 ? {} : _b;
    var Icon = isPlaying ? Pause : PlayArrow;
    var onClick = function () { return (isPlaying ? onPause() : onPlay()); };
    if (isLoading) {
        return (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "center", width: "100%" },
            React.createElement(IconButton, { size: "small", onClick: onPause },
                React.createElement(CircularProgress, { size: 15 }))));
    }
    return (React.createElement(IconButton, __assign({ size: "small", onClick: onClick }, iconButtonProps),
        React.createElement(Icon, null)));
};
